import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {Messages} from "../../Messages.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {ThankYouPanelStyle} from "./ThankYouPanel.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {DonationStore} from "../../../client/state/DonationStore.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {styleRuleInherit} from "../../../stem-core/src/decorators/Style.js";
import {redirectToMerchantHomepage} from "../../widget/misc/WidgetUtils.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";


class DonationUpdatedPanelStyle extends ThankYouPanelStyle {
    @styleRuleInherit
    button = {
        marginBottom: 8,
        marginTop: 0,
    }
}

@registerStyle(DonationUpdatedPanelStyle)
export class DonationUpdatedPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.donatePageDonationUpdatedTitle}</div>,
            <MessageElement message={Messages.donatePageDonationUpdatedText1(donation.formatPrice())}
                            className={styleSheet.text}/>,
            <div className={styleSheet.text}>{Messages.donatePageDonationUpdatedText2}</div>,
            <div className={styleSheet.text}>
                {Messages.donatePageDonationUpdatedText3}
                <Link className={styleSheet.dashboardLink} newTab href="/" value={Messages.dashboard}/>.
            </div>,
            <MerchantButton className={styleSheet.button} onClick={redirectToMerchantHomepage}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <PoweredByBlink />,
        ];
    }

    onMount() {
        this.attachChangeListener(DonationStore, () => {
            if (!iFrameUserDataService.getActiveRecurringDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            } else {
                this.redraw();
            }
        });
    }
}
